export default {
  app: {
    title: 'Statistiques',
    description: 'Suivez et analysez les performances de vos contenus',
  },
  common: {
    title: 'Statistiques',
    description: 'Suivez les performances et les statistiques',
    overview: 'Vue d\'ensemble',
    percentage: 'Pourcentage',
    average: 'Moyenne',
    vsPreviousPeriod: 'vs période précédente',
    noData: 'Aucune donnée disponible pour la période sélectionnée',
    loading: 'Chargement des données analytics...',
    error: 'Échec du chargement des données analytics',
    none: 'Aucun',
    loadMore: 'Charger plus',
    analytics: 'Analytiques',
  },
  header: {
    title: 'Vos',
    titleAccent: 'statistiques',
  },
  tabs: {
    coverage: 'Couverture',
    topAssets: 'Top des contenus',
    geography: 'Géographie',
    trafficSources: 'Sources de trafic',
    videoHeatmap: 'Heatmap',
    viewsOrigin: 'Origine des lectures',
    reviews: 'Avis',
    users: 'Utilisateurs',
    viewers: 'Audience',
    sales: 'Ventes',
    technical: 'Technique',
    audience: 'Audience',
    engagement: 'Engagement',
    contentAnalysis: 'Analyse contenu',
    domains: 'Domaines',
  },
  // A phone's picker for the tabs above, which do not fit there.
  viewPicker: {
    label: 'Vues des statistiques',
    open: '{view} : changer de vue',
  },
  coverage: {
    title: 'Couverture',
    description: 'Vue d\'ensemble des performances de votre contenu et de l\'engagement du public',
    empty: {
      title: 'Vos statistiques arrivent ici',
      description:
        'Voici à quoi ressemblera votre tableau de bord. Publiez et partagez une vidéo pour le voir prendre vie.',
      cta: 'Importer une vidéo',
    },
  },
  errors: {
    loadFailed: 'Échec du chargement des statistiques de couverture',
    loadAssetsFailed: 'Une erreur est survenue lors du chargement des assets',
    loadTrafficFailed: 'Une erreur est survenue lors du chargement des sources de trafic',
  },
  period: {
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    thisMonth: 'Ce mois-ci',
    lastMonth: 'Le mois dernier',
    thisYear: 'Cette année',
    custom: 'Période personnalisée',
  },
  dateRange: 'Période',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  quickShortcuts: 'Raccourcis rapides',
  shortcuts: {
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    thisMonth: 'Ce mois-ci',
    lastMonth: 'Mois dernier',
    thisYear: 'Cette année',
    lastYear: 'Année dernière',
  },
  metrics: {
    impressions: {
      label: 'Impressions',
      description: 'Nombre de fois où votre contenu a été affiché aux utilisateurs',
    },
    views: {
      label: 'Lectures',
      description: 'Nombre de fois où votre contenu a été réellement lu',
    },
    uniqueViewers: {
      label: 'Audience unique',
      description: 'Nombre d\'utilisateurs distincts ayant consulté votre contenu',
    },
    avgViewDuration: {
      label: 'Durée moy. de lecture',
      description: 'Temps moyen passé sur votre contenu par session',
    },
    totalWatchTime: {
      label: 'Temps de lecture total',
      description: 'Temps total cumulé passé sur l\'ensemble de votre contenu',
    },
    clickThroughRate: {
      label: 'Taux de clic',
      description: 'Pourcentage d\'impressions ayant abouti à des lectures (Lectures / Impressions)',
    },
    avgCompletionRate: {
      label: 'Taux de complétion moy.',
      description: 'Pourcentage moyen du contenu lu avant que les utilisateurs arrêtent',
    },
    assetsCount: {
      label: 'Médias',
      description: 'Nombre de fichiers médias inclus dans ces statistiques',
    },
    growth: 'Croissance',
    sessions: 'Sessions',
    bounceRate: 'Taux de rebond',
    pagesPerSession: 'Pages par session',
    newUsersPercentage: 'Nouveaux utilisateurs',
  },
  granularity: {
    hour: 'Heure',
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois',
  },
  charts: {
    timeSeries: 'Lectures et impressions',
    sessionsImpressions: {
      title: 'Lectures et impressions',
    },
    deviceType: {
      title: 'Répartition par appareil',
    },
    uniqueViewers: {
      title: 'Audience unique dans le temps',
    },
    watchTime: {
      title: 'Temps de lecture dans le temps',
      yAxisLabel: 'Durée',
    },
    uniqueViewersOverTime: 'Audience unique',
    watchTimeOverTime: 'Temps de lecture',
    deviceDistribution: 'Répartition par appareil',
    worldHeatmap: 'Distribution géographique',
    topAssets: 'Top des assets',
    topCountries: 'Top des pays',
    topReferrers: 'Top des référents',
    topTags: 'Top des tags',
  },
  origin: {
    worldHeatmap: {
      title: 'Lectures par pays',
    },
  },
  devices: {
    desktop: 'Ordinateur',
    tablet: 'Tablette',
    mobile: 'Mobile',
    smartTv: 'Smart TV',
    gameConsole: 'Console de jeux',
    bot: 'Robot',
    unknown: 'Inconnu',
  },
  contentTypes: {
    video: 'Vidéo',
    audio: 'Audio',
  },
  geography: {
    title: 'Analyse géographique',
    description: 'Découvrez d\'où vient votre audience et suivez les tendances géographiques',
    topCountries: 'Top des pays',
    views: 'lectures',
    regionalDistribution: 'Répartition régionale',
    continentalDistribution: 'Répartition continentale',
    topCities: 'Top des villes',
    totalCountries: 'Total des pays',
    topCountry: 'Premier pays',
    topContinent: 'Premier continent',
    topRegion: 'Première région',
    avgViewsPerCountry: 'Lectures moy. par pays',
    country: 'Pays',
    percentage: 'Part',
    growth: 'Croissance',
    viewAll: 'Voir tout',
    totalCountriesDesc: 'Nombre de pays lisant votre contenu',
    topCountryDesc: 'Pays avec le plus de lectures',
    topContinentDesc: 'Continent avec le plus de lectures',
    ofTotalViews: 'du total des lectures',
    avgViewsPerCountryDesc: 'Nombre moyen de lectures par pays',
    uniqueViewers: 'Audience unique',
    ctr: 'CTR',
    avgDuration: 'Durée moy.',
    noData: 'Aucune donnée géographique',
    noDataDesc: 'Les données géographiques apparaîtront une fois que votre contenu aura reçu des lectures',
    regions: 'régions',
  },
  trafficSources: {
    title: 'Sources de trafic',
    description: 'Domaines et pages où vos contenus sont intégrés et lus',
    trafficDistribution: 'Distribution du trafic',
    topSources: 'Top des sources',
    allReferrers: 'Tous les référents',
    views: 'Lectures',
    impressions: 'Impressions',
    viewers: 'Audience unique',
    direct: 'Trafic direct',
    directDesc: 'Visiteurs ayant saisi directement l\'URL',
    searchEngines: 'Moteurs de recherche',
    socialMedia: 'Réseaux sociaux',
    otherWebsites: 'Autres sites web',
    referralDesc: 'Sites web et blogs externes',
    ofTotal: 'du total',
    directTraffic: 'Direct',
    totalReferrers: 'Total des référents',
    totalReferrersDesc: 'Nombre de sources de trafic différentes',
    topReferrer: 'Premier référent',
    topReferrerDesc: 'Le plus de trafic depuis cette source',
    directTrafficDesc: 'Pourcentage de visiteurs directs',
    socialTraffic: 'Trafic social',
    socialTrafficDesc: 'Trafic provenant des réseaux sociaux',
    source: 'Source',
    ctr: 'CTR',
    avgDuration: 'Durée moy.',
    completion: 'Complétion',
    export: 'Exporter',
    social: 'Social',
    search: 'Recherche',
    sortByViews: 'Trier par lectures',
    sortByImpressions: 'Trier par impressions',
    sortByCTR: 'Trier par CTR',
    sortByViewers: 'Trier par audience',
    searchReferrers: 'Rechercher des référents...',
    referrerDomain: 'Domaine référent',
    uniqueViewers: 'Audience unique',
    trafficShare: 'Part du trafic',
    campaign: 'Campagne',
    utmDescription: 'Performance des campagnes suivies via les paramètres UTM',
    none: 'Aucun',
    noData: 'Aucune donnée de trafic',
    noDataDesc: 'Les données de sources de trafic apparaîtront une fois que votre contenu aura reçu des lectures',
  },
  filters: {
    title: 'Filtres',
    subtitle: 'Affinez vos données analytiques avec des filtres personnalisés',
    apply: 'Appliquer les filtres',
    clear: 'Effacer',
    activeCount: '{count} filtre(s) actif(s)',
    noActiveFilters: 'Aucun filtre actif',
    dateRange: 'Période',
    contentTypes: 'Type de contenu',
    devices: 'Appareils',
    devicesHint: 'Filtrer par type d\'appareil (ordinateur, mobile, tablette, etc.)',
    countries: 'Pays',
    countriesHint: 'Filtrer par localisation géographique',
    referrers: 'Référents',
    tags: 'Tags',
    tagsHint: 'Filtrer par tags de contenu',
    workspaces: 'Espaces de travail',
  },
  reviews: {
    title: 'Avis',
    description: 'Feedback et évaluations de votre audience',
    basedOn: 'Basé sur {count} avis',
    sortBy: 'Trier par',
    allRatings: 'Toutes les notes',
    all: 'Tous',
    export: 'Exporter',
    comments: 'Commentaires',
    recentReviews: 'Avis récents',
    helpful: 'Utile',
    reply: 'Répondre',
    noReviews: 'Aucun avis pour le moment',
    noReviewsDesc: 'Les avis apparaîtront ici une fois que votre audience commencera à évaluer votre contenu',
    noComment: 'Aucun commentaire fourni',
    mostRecent: 'Plus récents',
    byRating: 'Par note',
    oldest: 'Plus anciens',
    ratingAsc: 'Note croissante',
    ratingDesc: 'Note décroissante',
    assetsReviewed: 'Assets évalués',
    avgReviewsPerAsset: '{avg} avis par asset',
    avgRating: 'Note moyenne',
    avgRatingDesc: 'Note moyenne sur tous les avis',
    totalReviews: 'Total des avis',
    totalReviewsDesc: 'Nombre total d\'avis reçus',
    assetsReviewedDesc: 'Nombre d\'assets uniques avec des avis',
    reviewsPerAsset: 'Avis par asset',
    reviewsPerAssetDesc: 'Nombre moyen d\'avis par asset',
    satisfaction: 'Satisfaction',
    satisfactionDesc: 'Score de satisfaction global',
    ratingBreakdown: 'Répartition des notes',
    ratingDistribution: 'Distribution des notes',
    insights: 'Insights',
    positive: 'Positifs',
    neutral: 'Neutres',
    negative: 'Négatifs',
    positiveReviews: 'Avis positifs',
    neutralReviews: 'Avis neutres',
    negativeReviews: 'Avis négatifs',
    positiveReviewsDesc: 'Part des avis notés 4 ou 5 étoiles',
    neutralReviewsDesc: 'Part des avis notés 3 étoiles',
    negativeReviewsDesc: 'Part des avis notés 1 ou 2 étoiles',
    responseRate: 'Taux de réponse',
    reviews: 'avis',
    anonymous: 'Anonyme',
    contact: 'Contacter',
    viewAsset: 'Voir l\'asset',
    loadMore: 'Charger plus',
    loadingReviews: 'Chargement des avis...',
    filtersIgnored: "Une note ne porte ni appareil, ni pays, ni référent : ces filtres ne s'appliquent pas aux avis.",
    notForCollections:
      "Les notes portent sur un contenu, pas sur une collection. Ouvrez l'un de ses contenus pour lire ses avis.",
  },
  domains: {
    title: 'Domaines d\'intégration',
    description: 'Liste des sites où vos contenus sont intégrés, avec leurs performances',
    noData: 'Aucun domaine pour la période sélectionnée',
    stats: {
      totalDomains: 'Domaines',
      totalDomainsDesc: 'Nombre de domaines distincts intégrant vos contenus',
      totalSessions: 'Sessions',
      totalSessionsDesc: 'Sessions de lecture en embed sur la période',
      totalViews: 'Lectures',
      totalViewsDesc: 'Lectures cumulées via embed',
      totalWatchTime: 'Temps de lecture',
      totalWatchTimeDesc: 'Temps total lu via embed',
    },
    table: {
      title: 'Classement des domaines',
      domain: 'Domaine',
      sessions: 'Sessions',
      views: 'Lectures',
      uniqueViewers: 'Audience unique',
      urlCount: 'URLs',
      totalWatchTime: 'Temps total',
      avgWatchTime: 'Durée moyenne',
      avgCompletion: 'Complétion',
      firstViewedAt: 'Première lecture',
      lastViewedAt: 'Dernière lecture',
      url: 'URL',
      actions: 'Actions',
      viewMore: 'Voir plus',
      assetCount: 'Médias',
      viewMedia: 'Voir les médias',
    },
    tooltips: {
      domain: 'Nom de domaine du site qui héberge le player embed (ex: blog.acme.com).',
      url: 'URL complète où votre contenu est embarqué (scheme + domaine + chemin).',
      sessions: 'Nombre total de sessions de lecture lancées, y compris celles qui se terminent en moins de 10 secondes.',
      views: 'Nombre de sessions ayant duré plus de 10 secondes. Une "lecture" est une lecture significative, contrairement à une session qui peut être un rebond immédiat.',
      uniqueViewers: 'Nombre d\'utilisateurs distincts ayant lancé au moins une session. Calculé via un identifiant viewer généré côté player.',
      urlCount: 'Nombre d\'URLs distinctes (chemins) sur ce domaine où l\'un de vos contenus est intégré.',
      totalWatchTime: 'Temps cumulé de lecture sur toutes les sessions associées à ce domaine.',
      avgWatchTime: 'Durée moyenne d\'une session de lecture, toutes sessions confondues (rebonds inclus).',
      avgCompletion: 'Pourcentage moyen du contenu réellement lu par session. Vert ≥ 75%, orange 40-74%, rouge < 40%.',
      firstViewedAt: 'Date de la toute première session enregistrée sur ce domaine — indique quand l\'embed a commencé.',
      lastViewedAt: 'Date de la session la plus récente — utile pour détecter les embeds devenus inactifs.',
      assetCount: 'Nombre de médias (vidéo / audio) distincts intégrés sur cette URL.',
    },
    detail: {
      back: 'Retour aux domaines',
      description: 'Détail des URLs et performances pour ce domaine',
      visit: 'Visiter le site',
      unknownTitle: 'Domaine inconnu',
      notFound: 'Aucune donnée pour ce domaine',
      stats: {
        totalUrls: 'URLs',
        totalUrlsDesc: 'Nombre d\'URLs distinctes de ce domaine intégrant vos contenus',
      },
      urlsTable: {
        title: 'URLs sur ce domaine',
        url: 'URL',
      },
    },
    dialog: {
      title: 'Médias intégrés sur cette URL',
      assetName: 'Nom du média',
      noAssets: 'Aucun média trouvé pour cette URL',
      mediaCount: '{count} média | {count} médias',
    },
  },
  topAssets: {
    title: 'Top des contenus',
    description: 'Suivez les performances de vos contenus les plus performants',
    sortBy: 'Trier par',
    show: 'Afficher',
    days: 'jours',
    allTime: 'Tout le temps',
    assetName: 'Nom de l\'asset',
    views: 'Lectures',
    impressions: 'Impressions',
    ctr: 'CTR',
    uniqueViewers: 'Audience unique',
    avgDuration: 'Durée moy.',
    totalDuration: 'Durée totale',
    completion: 'Complétion',
    trend: 'Tendance',
    viewDetails: 'Voir les détails',
    viewHeatmap: 'Heatmap',
    showMore: 'Voir plus',
    fullRanking: 'Classement complet',
    noAssets: 'Aucun asset trouvé',
    noAssetsDesc: 'Téléchargez des assets pour commencer à suivre leurs performances',
    unavailableAsset: 'Contenu indisponible',
    metrics: {
      views: 'Lectures',
      impressions: 'Impressions',
      uniqueViewers: 'Audience unique',
      avgDuration: 'Durée moyenne',
      totalDuration: 'Durée totale',
      completion: 'Taux de complétion',
      ctr: 'Taux de clic',
    },
    limits: {
      top10: 'Top 10',
      top20: 'Top 20',
      top50: 'Top 50',
      top100: 'Top 100',
      all: 'Tous',
    },
  },
  export: {
    button: 'Exporter',
    excel: 'Excel (.xlsx)',
    error: 'Le fichier Excel n’a pas pu être généré. Réessayez dans un instant.',
  },
  videoHeatmap: {
    title: 'Heatmap d\'engagement',
    description: 'Analysez les modèles d\'engagement de votre audience tout au long de vos contenus',
    selectVideo: 'Sélectionner un contenu',
    searchPlaceholder: 'Rechercher un contenu...',
    noVideosFound: 'Aucun contenu trouvé',
    timeRange: 'Période',
    export: 'Exporter les données',
    totalViews: 'Lectures totales',
    totalSessions: 'Sessions totales',
    avgCompletion: 'Complétion moy.',
    avgWatchTime: 'Temps de lecture moy.',
    avgDuration: 'moy',
    videoDuration: 'Durée',
    peakTime: 'Pic d\'engagement',
    totalSessionsDesc: 'Nombre total de sessions de lecture de ce contenu',
    avgCompletionDesc: 'Pourcentage moyen du contenu lu par session',
    videoDurationDesc: 'Durée totale du contenu',
    peakTimeDesc: 'Moment du contenu avec le plus fort engagement',
    dropOffRate: 'Taux d\'abandon',
    engagementHeatmap: 'Heatmap d\'engagement',
    viewerEngagement: 'Engagement de l\'audience',
    viewDensity: 'Densité de lecture',
    absoluteViews: 'Lectures absolues',
    peakEngagement: 'Pic',
    highEngagement: 'Élevé',
    mediumEngagement: 'Moyen',
    lowEngagement: 'Faible',
    basedOn: 'Basé sur {count} lectures',
    recentSessions: 'Sessions récentes',
    sessionId: 'ID de session',
    user: 'Utilisateur',
    device: 'Appareil',
    country: 'Pays',
    watchPattern: 'Pattern de lecture',
    watchTime: 'Temps de lecture',
    completion: 'Complétion',
    engagement: 'Engagement',
    interactions: 'Interactions',
    seeks: 'Sauts',
    pauses: 'Pauses',
    date: 'Date',
    viewers: 'Audience',
    noVideoSelected: 'Aucun contenu sélectionné',
    selectVideoPrompt: 'Sélectionnez un contenu pour voir sa heatmap d\'engagement',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    last90Days: '90 derniers jours',
    allTime: 'Tout le temps',
    regions: 'régions',
    analyzingVideo: 'Contenu analysé',
    changeVideo: 'Changer',
    viewAsset: 'Voir le contenu',
    noStatsTitle: 'Aucune statistique pour ce contenu',
    noStatsDescription: 'Ce contenu n\'a pas encore été lu sur la période sélectionnée. Les statistiques apparaîtront dès les premières lectures.',
    noHeatmap: 'Aucune session de ce contenu sur la période sélectionnée ne porte de heatmap.',
    sessionsWithoutHeatmap:
      "{count} session enregistrée par le player ne porte pas de heatmap et n'est pas représentée. | {count} sessions enregistrées par le player ne portent pas de heatmap et ne sont pas représentées.",
    otherResolutions:
      "{count} session enregistrée à une autre résolution n'est pas représentée. | {count} sessions enregistrées à une autre résolution ne sont pas représentées.",
    watchedBy: "Sessions l'ayant lu",
  },
  users: {
    title: 'Statistiques utilisateurs',
    description: 'Suivez l\'activité, l\'engagement et les comportements des utilisateurs',
  },
  sales: {
    title: 'Statistiques des ventes',
    description: 'Suivez les revenus, les transactions et les performances de monétisation',
  },
  technical: {
    title: 'Statistiques techniques',
    description: 'Surveillez les performances du système, l\'utilisation des ressources et les métriques d\'infrastructure',
  },
  worldHeatmap: {
    watchTime: 'Temps de lecture',
    hours: 'heures',
  },
  viewers: {
    title: 'Statistiques d\'audience',
    description: 'Analysez l\'engagement et le comportement de l\'audience authentifiée',
    filterByAsset: 'Filtrer par contenu',
    allAssets: 'Tous les contenus',
    viewersList: 'Liste de l\'audience',

    // Summary stats
    totalViewers: 'Audience totale',
    totalViewersDesc: 'Utilisateurs authentifiés uniques ayant lu du contenu',
    totalSessions: 'Sessions totales',
    totalSessionsDesc: 'Nombre total de sessions des utilisateurs authentifiés',
    avgWatchTime: 'Temps moyen',
    avgWatchTimeDesc: 'Temps moyen passé par session',
    avgCompletion: 'Complétion moyenne',
    avgCompletionDesc: 'Pourcentage moyen de complétion du contenu',
    newViewers: 'Nouvelle audience',
    newViewersDesc: 'Audience avec première visite dans la période',
    recurringViewers: 'Audience récurrente',
    recurringViewersDesc: 'Audience revenue pour plusieurs sessions',
    engagementScore: 'Score d\'engagement',
    engagementScoreDesc: 'Score combiné basé sur le temps et la complétion',

    // Table columns
    email: 'Email',
    sessions: 'Sessions',
    assetsViewed: 'Contenus lus',
    totalWatchTime: 'Temps total',
    completion: 'Complétion',
    firstVisit: 'Première visite',
    lastVisit: 'Dernière visite',

    // Modal
    recentSessions: 'Sessions récentes',
    asset: 'Contenu',
    date: 'Date',
    watchTime: 'Temps de lecture',
    device: 'Appareil',
    location: 'Localisation',
    unknownAsset: 'Contenu inconnu',
    deletedAccount: 'Compte supprimé',
  },
}
